var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoShp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "4.11458in",
    height: "4.51667in",
    viewBox: "0 0 552 606",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 14.9109,
    x1: 274,
    y1: 106,
    x2: 349,
    y2: 106
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 14.9109,
    x1: 274,
    y1: 106,
    x2: 239,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 14.9109,
    x1: 203,
    y1: 106,
    x2: 239,
    y2: 195
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FEFEFE",
    stroke: "#332C2B",
    strokeWidth: 14.9109,
    cx: 203,
    cy: 106,
    r: 17
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FEFEFE",
    stroke: "#332C2B",
    strokeWidth: 14.9109,
    cx: 274,
    cy: 106,
    r: 17
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FEFEFE",
    stroke: "#332C2B",
    strokeWidth: 14.9109,
    cx: 239,
    cy: 195,
    r: 17
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FEFEFE",
    stroke: "#332C2B",
    strokeWidth: 14.9109,
    cx: 349,
    cy: 106,
    r: 17
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#332C2B",
    strokeWidth: 22.3664,
    strokeLinejoin: "round",
    points: "68,11 391,11 484,104 484,595 68,595"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332C2B",
    stroke: "#332C2B",
    strokeWidth: 18.6384,
    strokeLinejoin: "round",
    d: "M391 11l93 93 -47 0c-25,0 -46,-21 -46,-46l0 -47z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F8CCB5",
    y: 251,
    width: 552,
    height: 263,
    rx: 19,
    ry: 19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M120 403l22 -2c1,7 4,12 8,16 4,3 10,5 17,5 7,0 13,-1 16,-4 4,-4 6,-7 6,-11 0,-3 -1,-5 -2,-7 -2,-2 -5,-4 -9,-5 -2,-1 -8,-3 -18,-5 -12,-3 -21,-7 -26,-11 -7,-7 -10,-14 -10,-23 0,-6 2,-12 5,-17 3,-5 8,-8 14,-11 6,-3 13,-4 22,-4 14,0 25,3 32,9 7,7 11,15 12,26l-23 0c-1,-5 -4,-10 -7,-12 -3,-3 -8,-4 -14,-4 -7,0 -12,1 -16,4 -2,2 -3,4 -3,7 0,3 1,5 3,7 3,3 10,5 21,8 11,2 19,5 25,8 5,3 9,7 12,11 3,5 5,11 5,18 0,7 -2,13 -6,19 -3,5 -8,10 -15,12 -6,3 -15,5 -25,5 -14,0 -25,-4 -33,-10 -7,-7 -12,-17 -13,-29z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    points: "231,439 231,326 254,326 254,371 299,371 299,326 322,326 322,439 299,439 299,390 254,390 254,439"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M346 439l0 -113 36 0c14,0 23,1 28,2 6,1 12,5 16,11 4,6 7,13 7,22 0,7 -2,13 -4,18 -3,4 -6,8 -10,11 -4,2 -8,4 -12,5 -5,1 -13,2 -23,2l-15 0 0 42 -23 0zm23 -94l0 33 12 0c9,0 15,-1 18,-2 3,-1 6,-3 7,-6 2,-2 3,-5 3,-9 0,-4 -1,-7 -4,-10 -2,-3 -5,-4 -9,-5 -3,-1 -8,-1 -16,-1l-11 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShp);
export default __webpack_public_path__ + "static/media/logo_shp.21bd2b6308b818d610614ebb9293a4ba.svg";
export { ForwardRef as ReactComponent };